"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.fields = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _generateNewId = require("../../../../../helpers/generateNewId");
var _reorder = _interopRequireDefault(require("../../../../../helpers/reorder.js"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _style = _interopRequireDefault(require("../style.css"));
var _arrowResize = _interopRequireDefault(require("cccisd-icons/arrow-resize3"));
var _arrowResize2 = _interopRequireDefault(require("cccisd-icons/arrow-resize4"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _image = _interopRequireDefault(require("cccisd-icons/image2"));
var _paragraphLeft = _interopRequireDefault(require("cccisd-icons/paragraph-left"));
var _film = _interopRequireDefault(require("cccisd-icons/film4"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // Icons
var fields = exports.fields = ['infoBar.layout', 'infoBar.showHeader', 'infoBar.tabs[].id', 'infoBar.tabs[].layout', 'infoBar.tabs[].name', 'infoBar.tabs[].text', 'infoBar.tabs[].image', 'infoBar.tabs[].video', 'infoBar.tabs[].config.backgroundImage'];
var validate = exports.validate = function validate(values, props) {
  var errors = {};
  var regex = new RegExp('^(?:<iframe[^>]*)(?:(?:/>)|(?:>.*?</iframe>))$');
  values.infoBar.tabs.forEach(function (tab, i) {
    if ((0, _get2["default"])(values, "infoBar.tabs[".concat(i, "].name")) === '') {
      (0, _set2["default"])(errors, "infoBar.tabs[".concat(i, "].name"), 'You must enter a value');
    }
    var video = (0, _get2["default"])(values, "infoBar.tabs[".concat(i, "].video"));
    if (video && !regex.test(video)) {
      (0, _set2["default"])(errors, "infoBar.tabs[".concat(i, "].video"), 'Wrong video embed format.');
    }
  });
  return errors;
};
var _default = exports["default"] = function _default(props) {
  var _props$fields$infoBar = props.fields.infoBar,
    tabs = _props$fields$infoBar.tabs,
    layout = _props$fields$infoBar.layout,
    showHeader = _props$fields$infoBar.showHeader;
  var settings = props.settings;
  var layoutOptions = [{
    value: 'vertical',
    label: 'Vertical'
  }, {
    value: 'horizontal',
    label: 'Horizontal'
  }];
  var _useState = (0, _react.useState)(tabs[0].id.value),
    _useState2 = _slicedToArray(_useState, 2),
    currentTabId = _useState2[0],
    setCurrentTabId = _useState2[1];
  var headerLayoutOptions = [{
    value: 'text',
    label: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paragraphLeft["default"], {
      spaceRight: true
    }), /*#__PURE__*/_react["default"].createElement(_paragraphLeft["default"], null)),
    tooltip: 'Text only'
  }, {
    value: 'textImage',
    label: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paragraphLeft["default"], {
      spaceRight: true
    }), /*#__PURE__*/_react["default"].createElement(_image["default"], null)),
    tooltip: 'Text and image'
  }, {
    value: 'imageText',
    label: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_image["default"], {
      spaceRight: true
    }), /*#__PURE__*/_react["default"].createElement(_paragraphLeft["default"], null)),
    tooltip: 'Image and text'
  }, {
    value: 'textVideo',
    label: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paragraphLeft["default"], {
      spaceRight: true
    }), /*#__PURE__*/_react["default"].createElement(_film["default"], null)),
    tooltip: 'Text and video'
  }, {
    value: 'videoText',
    label: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_film["default"], {
      spaceRight: true
    }), /*#__PURE__*/_react["default"].createElement(_paragraphLeft["default"], null)),
    tooltip: 'Video and text'
  }];
  var onDragEnd = function onDragEnd(result) {
    var destination = result.destination,
      source = result.source;
    if (!destination) {
      return;
    }
    (0, _reorder["default"])(tabs, source.index, destination.index);
  };
  var getListStyle = function getListStyle(isDraggingOver) {
    return {
      overflow: 'auto',
      background: isDraggingOver ? '#eee' : '#fff',
      padding: '0 0 0 5px'
    };
  };
  var getItemStyle = function getItemStyle(isDragging) {
    return {
      userSelect: 'none',
      background: isDragging ? '#f0f0f0' : ''
    };
  };
  var handleAddHeaderTab = function handleAddHeaderTab() {
    tabs.addField({
      id: (0, _generateNewId.generateNewId)({
        prefix: 'header',
        settings: settings.infoBar.tabs
      }),
      name: 'New tab',
      layout: 'text',
      text: '',
      image: {
        id: 1,
        url: '',
        thumbnail: ''
      },
      video: '',
      config: {
        backgroundImage: true
      }
    });
  };
  var tabsHaveErrors = function tabsHaveErrors() {
    var error = false;
    tabs.forEach(function (tab, i) {
      var video = (0, _get2["default"])(tabs, "[".concat(i, "].video"));
      var name = (0, _get2["default"])(tabs, "[".concat(i, "].name"));
      if (video.error || name.error) {
        error = true;
      }
    });
    return error;
  };
  var _renderAddHeaderTabBtn = function _renderAddHeaderTabBtn() {
    if (tabs.length >= 5) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "You can't add more than 5 tabs."
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary ".concat(_style["default"].btnDisabled)
      }, "+ Add Header Tab"));
    }
    if (tabsHaveErrors()) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "One or more of your tabs have errors. Please fix them before adding more tabs."
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary ".concat(_style["default"].btnDisabled)
      }, "+ Add Header Tab"));
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary",
      onClick: handleAddHeaderTab
    }, "+ Add Header Tab");
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showHeader.value,
    onChange: function onChange() {
      return showHeader.onChange(!showHeader.value);
    },
    label: "Show Header?"
  }), showHeader.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group my-3 mx-0",
    role: "group",
    "aria-label": "..."
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Header tabs will be organized vertically or horizontally."
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Tab Layout"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group"
  }, layoutOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: option.value,
      type: "button",
      className: 'btn btn-secondary ' + (option.value === layout.value ? 'active' : ''),
      onClick: function onClick() {
        layout.onChange(option.value);
      }
    }, option.label);
  })))), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid ".concat(layout.value === 'vertical' && _style["default"].headerVert)
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable",
    direction: layout.value === 'vertical' ? 'vertical' : 'horizontal'
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef,
      style: getListStyle(snapshot.isDraggingOver),
      className: layout.value === 'vertical' ? _style["default"].tabsVert : _style["default"].tabs
    }), settings.infoBar.tabs.map(function (tab, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: tab.id,
        index: index,
        key: tab.id
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, {
          role: "presentation",
          key: 'key' + index,
          className: layout.value === 'vertical' ? _style["default"].tabVert : _style["default"].tab
        }), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: _style["default"].dragHandle
        }, dragProvided.dragHandleProps, {
          style: getItemStyle(dragSnapshot.isDragging, dragProvided.draggableProps.style)
        }), layout.value === 'vertical' ? /*#__PURE__*/_react["default"].createElement(_arrowResize2["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            flex: '1'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            padding: '1em',
            flexGrow: '1',
            textAlign: 'center'
          },
          className: tab.id === currentTabId ? _style["default"].activeTab : {}
        }, /*#__PURE__*/_react["default"].createElement("a", {
          onClick: function onClick() {
            return setCurrentTabId(tab.id);
          },
          style: tab.id === currentTabId ? {
            textDecoration: 'underline'
          } : {}
        }, tab.name || 'Unnamed Tab')), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            paddingRight: '0.5em'
          },
          className: tab.id === currentTabId ? _style["default"].activeTab : {}
        }, tabs.length > 1 && /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
          className: "btn btn-danger btn-xs",
          isConfirm: true,
          confirmationMessage: "Are you sure you want to delete this tab: ".concat(tab.name, "?"),
          onClick: function onClick() {
            tabs.removeField(index);
          }
        }))));
      });
    }), provided.placeholder, _renderAddHeaderTabBtn());
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab-content ".concat(_style["default"].headerContent)
  }, tabs.filter(function (tab) {
    return tab.id.value === currentTabId;
  }).map(function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(index === 0 ? 'active' : '', " tab-pane card card-body"),
      id: "tab".concat(tab.id.value),
      key: "tab".concat(tab.id.value),
      style: {
        backgroundColor: '#f5f5f5'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group d-inline-block my-3 mx-0"
    }, /*#__PURE__*/_react["default"].createElement("h4", null, "Header Layout"), headerLayoutOptions.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: option.tooltip,
        key: option.value
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: 'btn btn-secondary btn-sm ' + (option.value === tab.layout.value ? 'active' : ''),
        style: {
          marginRight: '0.5em'
        },
        onClick: function onClick() {
          tab.layout.onChange(option.value);
        }
      }, option.label));
    })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
      label: "Name",
      field: tab.name,
      required: true
    }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: tab.text,
      label: "Text"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
      field: tab.text,
      inputStyle: {
        minHeight: '100px'
      }
    })), ['textImage', 'imageText', ''].includes(tab.layout.value) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: '0.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
      value: (0, _get2["default"])(tab, 'image.value.id'),
      onChange: function onChange(value) {
        tab.image.onChange({
          id: value.id,
          url: value.url,
          thumbnail: value.thumbnailLarge
        });
      }
    })), tab.image && tab.image.value && tab.image.value.thumbnail && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, "Image Preview:"), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: tab.image.value.thumbnail,
      alt: "Header",
      style: {
        height: '150px'
      }
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-3 col-12 col-md-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Image will cover entire header background with text overlayed"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: tab.config.backgroundImage.value,
      onChange: function onChange() {
        return tab.config.backgroundImage.onChange(!tab.config.backgroundImage.value);
      },
      label: "Image cover header background?"
    }))))), ['textVideo', 'videoText', ''].includes(tab.layout.value) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
      label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Video (embed code)", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "e.g. < iframe ...> < /iframe>"
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null))),
      field: tab.video
    }), tab.video.value && !tab.video.error && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, "Video Preview:"), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: tab.video.value
    }))));
  }))))));
};